import { navigate } from "gatsby"
import { RequestError } from './index.d'

const ORIGIN = process.env.GATSBY_API_ORIGIN || 'https://api3.letsenhance.io'

const API_SUBMIT_APPLY_FORM = `${ORIGIN}/request-access`

export const submitForm = (
  values: any,
  setSubmitting:(submitting: boolean) => void,
  setStatus: (status: { submitted: boolean }) => void
) =>
  new Promise((resolve: () => void, reject: (err?: RequestError) => void) => {
    const xhr = new XMLHttpRequest()
    const { name, company, phone, email, comment, position, imagesAmount } = values

    setSubmitting(true)

    xhr.open('POST', API_SUBMIT_APPLY_FORM, true)
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')

    xhr.onload = () => {
      setSubmitting(false)

      if (xhr.status === 200) {
        setStatus({ submitted: true })

        navigate('/thankyou')

        resolve()
      } else {
        const res = JSON.parse(xhr.responseText);

        reject(res.errors)
      }
    }

    xhr.onerror = () => {
      setSubmitting(false)
      reject()
    }

    xhr.send(JSON.stringify({
      name,
      company,
      phone,
      email,
      comment,
      job_title: position,
      images_per_month: imagesAmount.value
    }))
  }
)
